/**
 *  Component: Link Settings Section
 */
import React, { useState } from 'react';

import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Button, StyledTextField } from 'styles/admin';
import { StyledTypography } from 'styles/common';

import { SettingsIconFilled } from 'constants/icons';

import { updateJiraAuthDetails } from 'services/plugins';
import { showErrorSnackbar } from 'services/snackbar';

import { BodyContainer, FormContainer, FormHeading, Separator, Icon } from '../styles';

const LinkSettingsSection = ({ reset }) => {
  const dispatch = useDispatch();
  const [displayName, setDisplayName] = useState('');
  const [workspaceUrl, setWorkspaceUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const saveConnection = () => {
    setLoading(true);
    updateJiraAuthDetails({ displayName, workspaceUrl })
      .then((res) => {
        setDisplayName('');
        setWorkspaceUrl('');
        reset();
      })
      .catch((err) => dispatch(showErrorSnackbar(err.message || 'Sorry, unable to save the details')))
      .finally(() => setLoading(false));
  };

  return (
    <FormContainer>
      <FormHeading>
        <Icon>
          <SettingsIconFilled size="fixed16px" />
        </Icon>
        Link Settings
      </FormHeading>
      <Separator />
      <BodyContainer>
        <Grid direction="column" container>
          <Grid xs={8}>
            <StyledTypography variant="body2" color="#666" topGutter={1}>
              Connection Name
            </StyledTypography>
            <Field
              compact
              fullWidth
              name="displayName"
              variant="outlined"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Enter connection name"
            />
          </Grid>
          <Grid xs={8}>
            <StyledTypography variant="body2" color="#666" topGutter={3}>
              URL
            </StyledTypography>
            <Field
              compact
              fullWidth
              name="workspaceUrl"
              variant="outlined"
              value={workspaceUrl}
              onChange={(e) => setWorkspaceUrl(e.target.value)}
              placeholder="Enter your company URL"
            />
          </Grid>
        </Grid>
        <StyledButton
          blue
          size="large"
          topGutter={4}
          onClick={saveConnection}
          disabled={loading || !workspaceUrl || !displayName}
        >
          Connect
        </StyledButton>
      </BodyContainer>
    </FormContainer>
  );
};

const Field = styled(StyledTextField)`
  input {
    padding: 12px 14px;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 1.75rem;
`;

export default LinkSettingsSection;
